import { formatInstantToPtBR } from '@/shared/lib';

export function formatMemberAuditDateTime(iso: string | undefined | null): string {
  return formatInstantToPtBR(iso);
}
